export default __webpack_public_path__ + "static/halfWidth2-3b7eaa1161f3e84cb11e2eea82b5b50a.png";